// base
import { createSlice } from '@reduxjs/toolkit';

// actions
import { RISK_ASSESSMENT_SLICE_NAME } from '../actions';

// models
import { RiskAssessmentState } from '../models';

// libraries
import dayjs from 'dayjs';
import { getRAManagementDetail, getRiskAssessmentManagementAttachments } from '../thunks';

// initialState
const initialState: RiskAssessmentState = {
  tbmStatusList: [],
  raId: 0,
  raMode: 'register',
  raApproval: null,
  raIssueBasicInfo: {
    validDateTo: dayjs().toDate(),
    validDateFrom: dayjs().toDate(),
    workDescription: '',
    disciplineId: '',
    status: 'DRAFT',
    coordinates: {
      lat: 0,
      lng: 0
    },
    workAreaDescription: ''
  },
  raIssueWorkList: [],
  raIssueApprovalUserList: [],
  raAttachmentList: [],
  raViewAttachmentList: []
};

// createSlice
const riskAssessmentSlice = createSlice({
  name: RISK_ASSESSMENT_SLICE_NAME,
  initialState,
  reducers: {
    setRaIssueBasicInfo: (state, action) => {
      state.raIssueBasicInfo = action.payload;
    },
    setRaIssueWorkList: (state, action) => {
      state.raIssueWorkList = action.payload;
    },
    setRaIssueApprovalUserList: (state, action) => {
      state.raIssueApprovalUserList = action.payload;
    },
    setRaAttachmentList: (state, action) => {
      state.raAttachmentList = action.payload;
    },
    setRaMode: (state, action) => {
      state.raMode = action.payload;
    },
    setApprovalStatus: (state, action) => {
      state.raIssueBasicInfo.status = action.payload;
    },
    setRaApproval: (state, action) => {
      state.raApproval = action.payload;
    },
    clearRaIssue: (state) => {
      state.raIssueBasicInfo = initialState.raIssueBasicInfo;
      state.raIssueWorkList = initialState.raIssueWorkList;
      state.raIssueApprovalUserList = initialState.raIssueApprovalUserList;
      state.raAttachmentList = initialState.raAttachmentList;
      state.raMode = initialState.raMode;
      state.raApproval = initialState.raApproval;
      state.raId = initialState.raId;
      state.raViewAttachmentList = initialState.raViewAttachmentList;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRAManagementDetail.fulfilled, (state, action) => {
        const res = action.payload;
        state.raAttachmentList = initialState.raAttachmentList;

        state.raIssueBasicInfo = {
          validDateTo: dayjs(res.resultObject.validDateTo).toDate(),
          validDateFrom: dayjs(res.resultObject.validDateFrom).toDate(),
          workDescription: res.resultObject.workDescription,
          disciplineId: res.resultObject.disciplineId,
          status: res.resultObject.status,
          coordinates: {
            lat: res.resultObject?.coordinates?.lat || 0,
            lng: res.resultObject?.coordinates?.lng || 0
          },
          workAreaDescription: res.resultObject.workAreaDescription,
          documentNumber: res.resultObject.documentNumber,
          companyName: res.resultObject.companyName,
          writerName: res.resultObject.writerName,
          issueDate: res.resultObject.issueDate,
          disciplineName: res.resultObject.disciplineName
        };
        state.raIssueWorkList = res.resultObject.workList;
        state.raIssueApprovalUserList = res.resultObject.approvalLineUsers;
        // 초기화
        state.raMode = 'view';
        state.raApproval = initialState.raApproval;
        state.raId = res.resultObject.id;
      })
      .addCase(getRiskAssessmentManagementAttachments.fulfilled, (state, action) => {
        state.raViewAttachmentList = action.payload.resultList;
      });
  }
});

export const riskAssessment = riskAssessmentSlice.name;
export const riskAssessmentReducer = riskAssessmentSlice.reducer;
export const riskAssessmentActions = riskAssessmentSlice.actions;
export default riskAssessmentSlice.reducer;
